/**
 * @description: Tracking Code Service.
 * @requires {Object} applicationModel
 * @requires {Object} parcelsService
 * @requires {Object} configService
 */
function trackingCodeService(applicationModel, parcelsService, configService) {

  /**
   * @description Check if a Google reCAPTCHA check needs to be triggered.
   * @returns {Boolean} True if we need to trigger a reCAPTCHA check, false instead.
   */
  const triggerGoogleRecaptchaCheck = () => {

    let googleRecaptchaCheckRequired = configService.google_recaptcha.enabled;
    let decodedSessionToken;

    // If there is a reCAPTCHA session token available, check if it is still
    // available, if yes no need to trigger a reCAPTCHA check.
    if (applicationModel.googleRecaptcha.sessionToken) {

      // Transform the Date().getTime() from milliseconds to seconds.
      const now = Math.floor(new Date().getTime() / 1000);

      decodedSessionToken = parcelsService.decodeJWT(applicationModel.googleRecaptcha.sessionToken);

      if (parcelsService.isSet(decodedSessionToken, 'exp') &&
        parseInt(decodedSessionToken.exp, 10) &&
        decodedSessionToken.exp > now) {

        googleRecaptchaCheckRequired = false;

      } else {

        // There is a google reCAPTCHA session token available but it has
        // expired, reset it in the model.
        applicationModel.googleRecaptcha.sessionToken = null;

      }

    }

    return googleRecaptchaCheckRequired;

  };

  return {
    triggerGoogleRecaptchaCheck
  };

}

export default trackingCodeService;



// WEBPACK FOOTER //
// ./src/components/trackingcode/tracking-code.service.js